import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const duo = defineConnector({
  identifier: "duo",
  name: "Duo Security",
  tagLine: "Multi-factor authentication",
  logo,
  protocol: "http",
  tags: ["it", "security"],
  defaultUrlPattern: ({ apiHost }) => domainToRegex(apiHost),
  auth: customAuth("duo"),
  steps: [
    {
      title: "Get your Duo Admin API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the Duo Admin Panel, go to **Applications > Protect an Application** and select **Admin API**. Copy the integration key, secret key, and API hostname.",
        },
      ],
    },
    {
      title: "Enter your Duo credentials",
      items: [
        {
          kind: "hostname",
          label: "API hostname",
          required: true,
          placeholder: "api-xxxxxxxx.duosecurity.com",
          target: { kind: "configuration", field: "apiHost" },
          helperText:
            "Your Duo API hostname, found on the application details page.",
        },
        {
          kind: "input",
          label: "Integration key",
          required: true,
          placeholder: "DIXXXXXXXXXXXXXXXXXX",
          target: { kind: "secrets", field: "integrationKey" },
          helperText: "Also called the client ID.",
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
          helperText: "Also called the client secret.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiHost }) => `https://${apiHost}/admin/v1/info/summary`,
  },
});
